module.exports = "/static/images/topograph-forest.webp";